<template>
  <div>
    <slot name="component">
      <Card :title="title" :footerDivider="footerDivider">
        <template v-slot:content>
          <span v-dompurify-html="text"></span>
          <slot name="content"></slot>
        </template>
        <template v-slot:footer>
          <div class="footer-cta footer-cta--left">
            <CustomButton
              v-if="primaryButtonText && primaryButtonLink"
              @click="() => onClick(primaryButtonLink)"
              :buttonColor="primaryButtonColor"
              :trackId="primaryTrackingId"
            >
              {{ primaryButtonText }}
            </CustomButton>
            <CustomButton
              v-if="secondaryButtonText && secondaryButtonLink"
              @click="() => onClick(secondaryButtonLink || '')"
              :buttonColor="secondaryButtonColor"
              :trackId="secondaryTrackingId"
            >
              {{ secondaryButtonText }}
            </CustomButton>
          </div>
        </template>
      </Card>
    </slot>
    <div v-if="showImage" class="imageWrapper">
      <slot name="image">
        <TeaserAccount></TeaserAccount>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type PropType } from 'vue'
import { navigate } from '@/utils/NavigationUtils'
import TeaserAccount from '@/componentsTenant/rahmen/images/TeaserAccount.vue'
import { ButtonColor, Card, CustomButton } from 'de-zurich-ui-library'

const props = defineProps({
  showImage: { type: Boolean, default: true },
  showAsBox: { type: Boolean, default: true },
  title: { type: String, default: '' },
  footerDivider: { type: Boolean, default: false },
  text: { type: String, default: '' },
  primaryButtonText: { type: String, default: '' },
  primaryButtonLink: { type: String, default: '' },
  primaryButtonColor: {
    type: String as PropType<ButtonColor>,
    default: ButtonColor.PRIMARY
  },
  primaryTrackingId: { type: String },
  secondaryButtonText: { type: String },
  secondaryButtonLink: { type: String },
  secondaryButtonColor: {
    type: String as PropType<ButtonColor>,
    default: ButtonColor.SECONDARY
  },
  secondaryTrackingId: { type: String },
  openLinkInSameTab: { type: Boolean, default: false }
})

const onClick = (link: string) => {
  navigate(link, false, props.openLinkInSameTab)
}
</script>

<style scoped>
.imageWrapper {
  padding-top: calc(var(--baseline) * 1.5);
}
</style>
